const characters = "abcdef0123456789";
const charactersLength = 16;
function generateTraceId() {
  let result = "";
  for (let i = 0; i < 16; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
const TRACE_HEADER_NAME = "x-b3-traceid";
const DEFAULT_TRACE_HOST_REG = /xiaohongshu.com/;

export { DEFAULT_TRACE_HOST_REG, TRACE_HEADER_NAME, generateTraceId };
